module.exports = __webpack_public_path__ + "img/product-wave-up.676b5ddc.svg";